'use client';

import {
  AttributeSideDynamic,
  AttributeSideDynamicAvailability,
} from '@eliadmin/core/src/components/categories/attributes/attribute';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Card } from '@eliadmin/core/src/components/ui/card';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
  SheetTitle,
} from '@eliadmin/core/src/components/ui/sheet';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { IoClose } from 'react-icons/io5';
import { TfiBrushAlt } from 'react-icons/tfi';

import { CiFilter } from 'react-icons/ci';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { RadioGroup, RadioGroupItem } from '@eliadmin/core/src/components/ui/radio-group';
import { Label } from '@eliadmin/core/src/components/ui/label';

const FilterSeparator = () => <Separator className="mx-4 w-auto last-of-type:hidden" />;

export function CategoryFilterSheet() {
  const templateSettings = useGlobalStore(state => state.templateSettings);
  const categoryTree = useCategoryStore(state => state.categoryTree);
  const category = useCategoryStore(state => state.category);
  const { t } = useTranslations();
  const clearFilter = useCategoryStore(s => s.clearFilters);
  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant={'outline'}
          className="flex w-full items-center justify-center gap-2 border-primary font-heading text-base font-normal uppercase text-primary"
        >
          <CiFilter size={20} /> {t('text174')}
        </Button>
      </SheetTrigger>
      <SheetContent className="z-[55] w-full px-0 py-0" showCloseIcon={false} aria-describedby={undefined}>
        <SheetTitle className="sr-only">{t('text174')}</SheetTitle>
        <Card
          className={cn(
            'relative h-screen max-h-screen overflow-auto bg-background',
            'ea-category-filter-sheet',
          )}
        >
          <div
            className={cn(
              'flex w-full flex-row items-center justify-between px-4 pb-5 pt-4',
              'ea-category-filter-sheet__expand-button',
            )}
          >
            <h3 className="font-heading text-2xl font-medium uppercase text-foreground">
              {t('text174')}
            </h3>
            <SheetClose aria-label="Zavrieť filter" className="inline-flex h-6 w-6 items-center justify-center p-0">
              <IoClose size={24} className="text-foreground" />
            </SheetClose>
          </div>
          <FilterSeparator />
          <div className={cn('mt-4 flex flex-col gap-6 pb-4', 'ea-category-filter-sheet__content')}>
            {/* attributes */}
            {!!templateSettings.category?.attributes_in_filter?.enabled && (
              // <div className={`order-${templateSettings.category.attributes_in_filter.order}`}>
              <>
                {category.attributes?.map((attribute, i) => (
                  <>
                    <AttributeSideDynamic
                      key={`attribute-${attribute.id ?? attribute.name}-${i}`}
                      name={attribute.name}
                      attribute={attribute as any}
                      className={{ wrapper: cn('', 'ea-category-filter-sheet__attributes') }}
                    />
                    <FilterSeparator />
                  </>
                ))}
              </>
            )}
            {!!templateSettings.category?.availability_in_filter?.enabled &&
              !!category.availabilities?.length && (
                <>
                  <AttributeSideDynamicAvailability
                    name={t('text339')}
                    availabilities={category.availabilities}
                    className={{ wrapper: cn('', 'ea-category-filter-top__availabilities') }}
                  />
                  <FilterSeparator />
                </>
              )}
            <div className="flex flex-col gap-4 px-4">
              <span className="font-heading text-lg font-normal uppercase text-foreground">
                ZORADIŤ PODĽA
              </span>
              <RadioGroup
                value={selectedValue}
                onValueChange={onSortChange}
                className={cn('flex flex-col space-y-2', 'ea-category-sort-radio')}
              >
                {VALUES.map(option => (
                  <div
                    key={`sort-option-${option.value}`}
                    className={cn(
                      'flex flex-row items-center space-x-2',
                      'ea-category-sort-radio__input-wrapper',
                    )}
                  >
                    <RadioGroupItem
                      value={option.value}
                      id={`sort-option-${option.value}`}
                      className={cn(
                        'ea-category-sort-radio__item-input-sort rounded-none border shadow-none w-5 h-5',
                        selectedValue === option.value ? 'border-primary' : 'border-border',
                      )}
                    />
                    <Label
                      htmlFor={`sort-option-${option.value}`}
                      className="text-sm text-foreground"
                    >
                      {t(option.label)}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </div>
            {/* <FilterSeparator />
            {/* categories */}
            {/* {!!templateSettings.category?.tree_list?.enabled && !!categoryTree && (
              <AttributeCategory order={templateSettings.category.tree_list.order} />
            )} */}

            {/* <FilterSeparator /> */}

            {/* subcategories */}
            {/* {!!templateSettings.category?.categories_in_filter?.enabled &&
              !!category.sub_categories?.length && (
                <>
                  <AttributeSide
                    name={t('text337')}
                    type="subCategory"
                    attribute={{ type: 'status', type2: 'statuses' }}
                    order={templateSettings.category.categories_in_filter.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__subcategories') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* manufacturers */}
            {/* {!!templateSettings.category?.manufacturers_in_filter?.enabled &&
              !!category.manufacturers?.length && (
                <>
                  <AttributeSide
                    name={t('text195')}
                    type="generic"
                    attribute={{ type: 'manufacturer', type2: 'manufacturers' }}
                    order={templateSettings.category.manufacturers_in_filter.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__manufacturers') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* statuses */}
            {/* {!!templateSettings.category?.statuses_in_filter?.enabled &&
              !!category.statuses?.length && (
                <>
                  <AttributeSide
                    name={t('text518')}
                    type="generic"
                    attribute={{ type: 'status', type2: 'statuses' }}
                    order={templateSettings.category?.categories_in_filter?.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__statuses') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* availabilities */}
            {/* {!!templateSettings.category?.availability_in_filter?.enabled &&
              !!category.availabilities?.length && (
                <>
                  <AttributeSide
                    name={t('text339')}
                    type="generic"
                    attribute={{ type: 'availability', type2: 'availabilities' }}
                    order={templateSettings.category.availability_in_filter.order}
                    className={{ wrapper: cn('', 'ea-category-filter-sheet__availabilities') }}
                  />
                  <FilterSeparator />
                </>
              )} */}

            {/* price */}
            {/* {!!templateSettings.category?.price_in_filter?.enabled && (
              <>
                <AttributeSide
                  name={t('text340')}
                  type="price"
                  attribute={{ type: 'status', type2: 'statuses' }}
                  order={templateSettings.category.price_in_filter.order}
                  className={{ wrapper: cn('', 'ea-category-filter-sheet__price') }}
                />
                <FilterSeparator />
              </>
            )} */}
            {/* 
            {!!templateSettings.category?.suppliers_in_filter?.enabled && (
              <>
                <AttributeSide
                  name={t('text718')}
                  type="generic"
                  attribute={{ type: 'supplier', type2: 'suppliers' }}
                  className={{ wrapper: cn('', 'ea-category-filter-sheet__suppliers') }}
                  order={templateSettings.category.suppliers_in_filter.order}
                />
                <FilterSeparator />
              </>
            )}
            {!!templateSettings.category?.suppliers_location_in_filter?.enabled && (
              <>
                <AttributeSide
                  name={t('text728')}
                  type="supplierLocation"
                  attribute={{ type: 'supplier', type2: 'suppliers' }}
                  className={{ wrapper: cn('', 'ea-category-filter-sheet__suppliers_location') }}
                  order={templateSettings.category?.suppliers_in_filter?.order}
                />
                <FilterSeparator />
              </>
            )} */}
          </div>

          <div className="sticky bottom-0 flex flex-1 flex-col justify-end gap-2 bg-white pb-2">
            <Separator />
            <div className="flex w-full items-center justify-between gap-3.5 p-3.5">
              <SheetClose asChild>
                <Button className="w-full">{t('text1380')}</Button>
              </SheetClose>
              <SheetClose
                onClick={clearFilter}
                aria-label="Vymazať filtre"
                className="flex min-h-12 min-w-12 items-center justify-center border border-primary text-primary"
              >
                <TfiBrushAlt size={20} />
              </SheetClose>
            </div>
          </div>
        </Card>
      </SheetContent>
    </Sheet>
  );
}
